var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iframe-link"
  }, [_c('a', {
    ref: "iframe-link",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.content))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }